import { App } from 'map-feature-info'
import { Map } from '~map-preview/types/__generated/gql/graphql'
import { useIsEmbed } from '~map-preview/hooks/useIsEmbed'
import { useMapDataWithAggregateProperties } from '~map-preview/hooks/useMapDataWithAggregateProperties'
import { useTitleProperty } from '~map-preview/states/map'
import { useMapNavStore } from '~map-preview/states/mapNav'

const MapFeatureInfo = () => {
  const { openMapFeatureInfo } = useMapNavStore()
  const isEmbed = useIsEmbed()
  const map = useMapDataWithAggregateProperties()
  const title = useTitleProperty()

  return (
    <App
      isEmbed={isEmbed}
      title={title?.name || 'Name'}
      map={map as Map}
      open={openMapFeatureInfo}
    />
  )
}

export { MapFeatureInfo }
